import BannerBlock from './BannerBlock/BannerBlock'
import CalendarBlock from './CalendarBlock/CalendarBlock'
import GalleryBlock from './GalleryBlock/GalleryBlock'
import NewsGridBlock from './NewsGridBlock/NewsGridBlock'

import style from './newspage.module.scss'

const NewsPage = () => {
    return (
        <div className={style.newspage}>
            <BannerBlock />
            <CalendarBlock />
            <GalleryBlock />
            <NewsGridBlock />
        </div>
    )
}

export default NewsPage